import { render, staticRenderFns } from "./IdCardMembershipList.vue?vue&type=template&id=496f8bac"
import script from "./IdCardMembershipList.vue?vue&type=script&lang=js"
export * from "./IdCardMembershipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports